import React from 'react'

function Section7() {
    return (
        <div id='section7' className='d-block mx-auto'>
             <div className='home-container container mx-auto vertical-center' style={{borderColor:"black",borderRadius:"2em",overflow:"none"}}>
               <div className='col-lg'>
                   <img className="home-image" data-aos="zoom-in-right" src="images/chefs.jpg" style={{borderRadius:"2em",minWidth:"300px",minHeight:"300px"}} ></img>
               </div>
               <div className='col-lg'>
                   <h1 className='myDiv' style={{color:"#ec8649",fontFamily:"Arkipelago",textTransform:"none",fontSize:"3em",whiteSpace:"no-wrap"}}>World class chefs</h1>
                   <h4 style={{color:"white"}}>Delicious food made by the best of chefs with the purest ingredients.</h4>
               </div>
           </div>
           
        </div>
    )
}

export default Section7;
